import { TOGGLE_LIST_SHARE } from '../actions';

type State =
  | {
      openShareId: string | null;
    }
  | undefined;

type Action = {
  type: 'TOGGLE_LIST_SHARE';
  uid: string;
};

export default function publicListReducer(state: State, action: Action) {
  if (!state) {
    return {
      openShareId: null,
    };
  }

  switch (action.type) {
    case TOGGLE_LIST_SHARE: {
      return {
        ...state,
        openShareId: !state.openShareId ? action.uid : null,
      };
    }

    default:
      return state;
  }
}
